export default "__VITE_ASSET__COwmuxbX__"